import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import { applyTemplate } from "../../../services/integrations/klaviyoEventMappingsService";

export default function StarterPackModal({ visible, onClose, onRefresh }) {
  const [applying, setApplying] = useState(false);

  const handleApply = async () => {
    setApplying(true);
    try {
      const result = await applyTemplate("klaviyo-starter-pack");
      const count = result?.mappingsCreated ?? 5;
      message.success(`Starter pack applied: ${count} mappings created`);
      onRefresh();
      onClose();
    } catch (err) {
      message.error("Failed to apply starter pack");
    }
    setApplying(false);
  };

  return (
    <Modal
      title="Apply Klaviyo Starter Pack?"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" className="standard-button secondary-orange-button" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="apply"
          className="standard-button primary-orange-button"
          loading={applying}
          onClick={handleApply}
        >
          Apply Starter Pack
        </Button>,
      ]}
    >
      <p>This will create:</p>
      <ul>
        <li>
          <strong>3 event mappings</strong>
          <ul>
            <li>polly.conversation_closed &rarr; "Polly Conversation Closed"</li>
            <li>polly.sentiment_computed &rarr; profile attrs + "Polly Sentiment Computed"</li>
            <li>polly.question_asked &rarr; "Polly Question Asked"</li>
          </ul>
        </li>
        <li>
          <strong>2 attribute mappings</strong>
          <ul>
            <li>polly_sentiment_overall &rarr; polly_sentiment_overall</li>
            <li>polly_sentiment_confidence &rarr; polly_sentiment_confidence</li>
          </ul>
        </li>
      </ul>
      <p style={{ color: "#888", fontSize: 13 }}>
        You can edit or remove any of these afterward.
      </p>
    </Modal>
  );
}
